import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { CurrencyWithPrice } from "../../CurrencyWithPrice";
import LoadingButton from "../../LoadingButton";
import { PricingFooter } from "../PricingFooter";
import { Price } from "../types";

export enum SubmitType {
  Continue,
  Customize,
  AddToCart,
}

export type FooterProps = {
  loading: boolean;
  currencyCode: string;
  locale: string;
  quantity: number;
  moq: number;
  price: Price | null;


  handleSubmit: (stype: SubmitType) => void;
  graphicMode?: boolean;

  translations: {
    continue: string;
    customize: string;
    addToCart: string;
    uploadText: string;
  };
};

const Footer = (props: FooterProps) => {
  return (
    <PricingFooter
      sx={{
        mt: { xs: 2, md: 1 },
        paddingLeft: "18px",
        paddingRight: "18px",
        paddingBottom: 1,
        paddingTop: "20.67px",
        color: "#7f8481",
        fontSize: 12,
      }}
    >
      {props.graphicMode ? (
        <Button
          fullWidth
          variant="outlined"
          color="primary"
          sx={{ backgroundColor: "#fff", marginBottom: 1.25 }}
          disabled={!props.price || props.quantity < props.moq || props.loading}
          onClick={() => props.handleSubmit(SubmitType.Customize)}
        >
          {props.translations.customize}
        </Button>
      ) : null}

      <Button
        fullWidth
        variant="contained"
        color="primary"
        disabled={!props.price || props.quantity < props.moq || props.loading}
        onClick={() =>
          props.handleSubmit(
            props.graphicMode ? SubmitType.AddToCart : SubmitType.Continue
          )
        }
      >
        {props.graphicMode
          ? props.translations.addToCart
          : props.translations.continue}{" "}
        {props.graphicMode ? " - " : null}
        {props.graphicMode ? (
          <Box component="span" sx={{ ml: 1 }}>
            {" "}
            <CurrencyWithPrice
              locale={props.locale}
              price={props.price?.price || null}
              currencyCode={props.currencyCode || ""}
            />
          </Box>
        ) : null}
      </Button>
      {!props.graphicMode && props.translations.uploadText ? (
        <Typography
          variant="caption"
          component="p"
          sx={{
            textAlign: "right",
            marginTop: "20px",
            color: "#676767",
            fontSize: "10px",
            lineHeight: "16px",
          }}
        >
          {props.translations.uploadText}
        </Typography>
      ) : null}
    </PricingFooter>
  );
};

export default Footer;
